/**
 * Règles d'affichage des colonnes par shipment_stage
 *
 * hiddenColumns: colonnes à masquer pour ce stage
 * boldColumns: colonnes à afficher en gras pour ce stage
 */
export const SHIPMENT_STAGE_DISPLAY_RULES = {
  'A TRAITER': {
    hiddenColumns: ['chartering_datetime', 'client_vat', 'carrier_vat', 'invoicing_status'],
    boldColumns: ['client', 'pickup_date', 'delivery_date'],
  },
  'EN COURS': {
    hiddenColumns: [],
    boldColumns: ['pickup_date', 'delivery_date'],
  },
  LIVRÉ: {
    hiddenColumns: [],
    boldColumns: ['pickup_date', 'delivery_date'],
  },
};

/**
 * Applique les règles d'affichage aux colonnes selon le shipment_stage
 * @param {Array} columns - Liste des colonnes
 * @param {string} shipmentStage - Stage actuel (A TRAITER, EN COURS, LIVRÉ)
 * @returns {Array} Colonnes filtrées et avec propriété bold
 */
export function applyColumnDisplayRules(columns, shipmentStage) {
  const rules = SHIPMENT_STAGE_DISPLAY_RULES[shipmentStage];

  if (!rules) {
    return columns;
  }

  return columns
    .filter(col => !rules.hiddenColumns.includes(col.dataField))
    .map(col => ({
      ...col,
      bold: rules.boldColumns.includes(col.dataField),
    }));
}
